export default "__VITE_ASSET__dCgEaAYC__"